const formatAddress = (address: string, startIndex = 5, endIndex = 5): string => {
  if(!address) return ''
  return `${address.slice(0, startIndex)}...${address.slice(address.length - endIndex)}`;
};

export default formatAddress;
